import React from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';
import { Box } from '@hz-design-system/web-ui';
import dynamic from 'next/dynamic';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';
import { ListingDate, ListingPriority, ListingSellerName } from '@/client/components/ListingsNew/components';
import ListingLocationDetails from '@/client/components/ListingsNew/components/ListingLocationDetails/ListingLocationDetails';

import Classes from './ListingSellerInfoPriority.module.scss';

const ListingSellerExternalLink = dynamic(
  () => import('@/client/components/ListingsNew/components/ListingSellerExternalLink/ListingSellerExternalLink'),
  { ssr: false },
);

interface ListingSellerInfoPriorityProps {
  sellerInformation?: TSellerInformation;
  isVerifiedSeller: boolean;
  location?: { label: string; distance?: string };
  date?: string;
  priorityProduct?: string;
}

const ListingSellerInfoPriority: React.FC<ListingSellerInfoPriorityProps> = ({
  sellerInformation,
  isVerifiedSeller,
  location,
  date = '',
  priorityProduct = '',
}) => {
  return (
    <Box name="Listing-sellerInfoPriority" as="div" className={Classes['hz-Listing-sellerInfoPriority']}>
      <Box as="div" name="Listing-sellerInfo-top" className={Classes['hz-Listing-sellerInfo-top']}>
        {sellerInformation && (
          <ListingSellerName link={sellerInformation.soiUrl} isVerifiedSeller={isVerifiedSeller}>
            {sellerInformation.sellerName}
          </ListingSellerName>
        )}
        {location && <ListingLocationDetails.Regular location={location} />}
        <ListingDate.Regular date={date} />
      </Box>

      <Box as="div" name="Listing-sellerInfo-bottom" className={Classes['hz-Listing-sellerInfo-bottom']}>
        <ListingPriority.Regular priorityProduct={priorityProduct} />
        {sellerInformation?.showWebsiteUrl && (
          <Box
            as="span"
            name="Listing-sellerLink"
            className={Classes['hz-Listing-sellerLink']}
            suppressHydrationWarning
          >
            <ListingSellerExternalLink
              url={sellerInformation?.sellerWebsiteUrl}
              className={getSuitCSSClasses({
                namespace: 'hz',
                name: 'TextLink',
              })}
            >
              <Trans tagName="span" i18nKey="listings.visit" />
            </ListingSellerExternalLink>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ListingSellerInfoPriority;
